module.exports = __webpack_public_path__ + "static/packing-63dbe346f7f8bbda8a193289c2fae00d.jpg";